var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"_pt0 _pb0 bg-white section-header"},[_c('div',{attrs:{"container":""}},[_vm._t("text"),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }